<template lang='pug'>
  #upgrade.view.container
    digi-landing(:info='step0')
</template>

<script>
export default {
  name: 'upgrade.view',

  data() {
    return {
      step0: {
        header: 'Your Business Deserves To Take-Off',
        text: 'Frustrated with an outdated website? Upgrade to a Progressive Web App and watch your revenues soar',
        type: 'email',
        placeholder: 'Your Email',
        button: 'Get Your Quote',
        svg: '/liftoff.svg'
      }
    }
  },

  methods: {
  }
}
</script>

<style scoped lang='stylus'>
  #upgrade
    overflow hidden
    @media(max-width: 480px)
      text-align center
</style>